import Common from './common';
import System from './system';
import Device from './device';
import Content from './content';
import Strategy from './strategy';
import Customer from './customer';
import App from './app';
import SaleService from './saleService';
import Statistics from './statistics';
import Ota from './ota';

const routers = Common.concat(SaleService).concat(System).concat(Device).concat(Content).concat(Strategy).
    concat(Customer).concat(App).concat(Statistics).concat(Ota);

export default routers



// WEBPACK FOOTER //
// ./src/routers/index.js